import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { RosterContactScreen } from '@/features/hr-reports/roster-contact-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/roster-contact')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: RosterContactScreenRoute,
})

function RosterContactScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <RosterContactScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/roster-contact', search: next })}
    />
  )
}
